<div style="display: flex; align-items: center; gap: 10px;">
    <app-select [elements]="types" [parentFormGroup]="parentFormGroup" parentFormControlName="typeValue"></app-select>
    <app-date-picker *ngIf="dateSelected()"
                     [parentFormGroup]="parentFormGroup"
                     parentFormControlName="date"></app-date-picker>
    <app-select-filter *ngIf="monthSelected()" [parentFormGroup]="parentFormGroup"
                       noEntriesFoundLabel="Aucun mois trouvé"
                       parentFormControlName="month"
                       [elements]="months"
    ></app-select-filter>
    <app-select-filter *ngIf="monthSelected() || yearSelected()" [parentFormGroup]="parentFormGroup"
                       noEntriesFoundLabel="Aucune année trouvée"
                       parentFormControlName="year"
                       [elements]="years"
    ></app-select-filter>
    <p (click)="onDeleteCustomDate()" class="link cursor-pointer" style="font-size: 0.8em;">Effacer</p>
</div>
